import Divider from 'components/shared/Divider/Divider';

import { getEffectiveAccent, isTwoColor, resolveBranding } from '../lib';

import ColorGrid from './ColorGrid';
import StyleSelector from './StyleSelector';
import ShadeSelector from './ShadeSelector';
import AccentSelector from './AccentSelector';

const SectionLabel = ({ children }) => (
  <p className="text-sm leading-[22px] text-neutral-800">{children}</p>
);

const BrandSidepanel = ({ draft, onChange }) => {
  const resolved = resolveBranding(draft);
  const accent = getEffectiveAccent(draft);

  return (
    <aside className="flex w-1/3 min-w-80 max-w-md shrink-0 flex-col gap-6 overflow-y-auto border-0 border-r border-solid border-neutral-200 bg-white p-5 sm:p-4 xs:w-full xs:min-w-0 xs:max-w-none xs:overflow-visible xs:border-b xs:border-r-0 xs:p-5">
      <div className="flex flex-col gap-3">
        <SectionLabel>Style</SectionLabel>
        <StyleSelector
          value={draft.style}
          primary={resolved.primary_color}
          accent={resolveBranding({ ...draft, style: 'two' }).secondary_color}
          onChange={(style) => onChange({ style })}
        />
      </div>

      <Divider />

      <div className="flex flex-col gap-3">
        <SectionLabel>Main color</SectionLabel>
        <ColorGrid
          value={draft.main_color}
          shade={draft.main_shade}
          onChange={(main_color) => onChange({ main_color })}
        />
      </div>

      <div className="flex flex-col gap-3">
        <SectionLabel>Shade</SectionLabel>
        <ShadeSelector
          colorKey={draft.main_color}
          value={draft.main_shade}
          onChange={(main_shade) => onChange({ main_shade })}
        />
      </div>

      {isTwoColor(draft) && (
        <>
          <Divider />
          <div className="flex flex-col gap-3">
            <SectionLabel>Accent color</SectionLabel>
            <AccentSelector draft={{ ...draft, accent_color: accent.key }} onChange={onChange} />
          </div>
        </>
      )}
    </aside>
  );
};

export default BrandSidepanel;
